import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';

@Injectable({
  providedIn: 'root'
})
export class OpenaiService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/open-ai`;

  async generateTextViaOpenAi(prompt: string, image?: string): Promise<any>{
    return this.request(() => this.http.post(`${this.url}/generate-description`, {prompt: prompt, image: image}).toPromise());
  }
}
